import React from 'react';
import { useNavigate } from 'react-router-dom';
import TopMenu from './topMenu.js';
import './NotFound.css';
import sadRobot from '../Ui/wired-gradient-500-fingerprint-security.gif';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="notfound-container">
      <TopMenu />
      <div className="notfound-content">
        <img src={sadRobot} alt="404 animation" className="notfound-animation" />
        <h1>Sorry, there's nothing here right now</h1>
        <p>The page you requested does not exist or is not available.</p>
        <button className="notfound-back" onClick={() => navigate(-1)}>Go Back</button>
      </div>
    </div>
  );
};

export default NotFound;